import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { getCities } from "../../actions/userActions/cityAction";
import { getTeams } from "../../actions/userActions/teamAction";
import GenericFilter, { FilterBar } from "../subComponents/Filter/GenericFilters";
import CustomFilterSelect from "../designSystem/CustomFilterSelect";
import { deleteVisitProfile, getvisitProfile } from "../../actions/userActions/VisitProfileAction";
import SearchInput from "../subComponents/search/SearchInput";
import CustomButton from "../subComponents/buttons/CustomButton";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CustomPagination from "../subComponents/pagination/CustomPagination";
import Heading6Regular from "../designSystem/Heading6Regular";
import './VisitProfile.css';
import deleteIcon from "../../assets/images/deleteIcon_drawer.svg";
import Heading6Semibold from "../designSystem/Heading6Semibold";
import BodyMediumRegular from "../designSystem/BodyMediumRegular";
import BodyExtraSmallMedium from "../designSystem/BodyExtraSmallMedium";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import thIcon from "../../assets/images/thIcon.svg";
import DynamicTable from "../reuse_components/DynamicTable";
import {
    DEFAULT_PAGE,
    DEFAULT_PAGE_SIZE,
    DEFAULT_SEARCH,
} from '../../Constatns';
import { PERMISSIONS } from "../../Permissions";
import ItemsPerPageSelector from "../subComponents/pagination/ItemsPerPageSelector";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import { t } from "../../locales/translate";
// Constants for state persistence
const VISIT_PROFILE_STATE_KEY = "visitProfileFiltersState";
const MODULE_FLAG = "insideVisitProfileModule";
const VISIT_PROFILE_ROUTES = [
    "/admin/visitprofile",
    "/admin/addvisitprofile",
    "/admin/updatevisitprofile",
];

const isVisitProfileModulePath = (path = "") =>
    VISIT_PROFILE_ROUTES.some(route => path.toLowerCase().includes(route));
const VisitProfile = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const visitProfile = useSelector((state) => state.visitProfile_reducer.visitProfile);
    const assigneeListRef = useRef(null);
    const permissions = JSON.parse(localStorage.getItem("permissionsList"));
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [selectedVisitProfileId, setSelectedVisitProfileId] = useState(null);
    const [expandedRowId, setExpandedRowId] = useState(null);
    const [isReady, setIsReady] = useState(false);
    const [initialLoad, setInitialLoad] = useState(true);
    const modalRef = useRef(null);
    const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_PAGE_SIZE);
    const isLoading = useSelector((state) => state.visitProfile_reducer.isVisitProfileLoading);
    const allCities = useSelector((state) => state.cities_reducer.cities);
    const allTeams = useSelector((state) => state.teams_reducer.teams);
    const user = JSON.parse(localStorage.getItem("user"));
    const currentUserCityId = user?.result[0]?.user?.cityId || '';
    const currentUserTeamId = user?.result[0]?.user?.teamId || '';
    console.log('Current User Data:', user);
console.log('Current User City ID:', currentUserCityId);
console.log('Current User Team ID:', currentUserTeamId);

// Prepare filter options
const citydata = allCities?.result;
const cityOptions = citydata?.map(city => ({
    id: String(city.id), 
    name: city.name
})) || [];
const teamdata = allTeams?.result;
const teamOptions = teamdata?.map(team => ({
    id: String(team.id),
    name: team.name
})) || [];
    const [showFilters, setShowFilters] = useState(false);
    const [cityFilter, setCityFilter] = useState('');
    const [teamFilter, setTeamFilter] = useState('');
    const [citiesLoaded, setCitiesLoaded] = useState(false);
    const [teamsLoaded, setTeamsLoaded] = useState(false);
    const [isInitialized, setIsInitialized] = useState(false);
    useEffect(() => {
    console.log('Team Options:', teamOptions);
    console.log('Teams Loaded:', teamsLoaded);
    console.log('All Teams:', allTeams);
}, [teamOptions, teamsLoaded, allTeams]);
  useEffect(() => {
    if (allTeams && allTeams.result && allTeams.result.length > 0) {
        console.log('Teams available in Redux:', allTeams.result.length);
        setTeamsLoaded(true);
    }
}, [allTeams]);

useEffect(() => {
    if (allCities && allCities.result && allCities.result.length > 0) {
        console.log('Cities available in Redux:', allCities.result.length);
        setCitiesLoaded(true);
    }
}, [allCities]);
    useEffect(() => {
    const clearModuleState = () => {
        sessionStorage.removeItem(MODULE_FLAG);
        localStorage.removeItem(VISIT_PROFILE_STATE_KEY);
    };
    const unlisten = history.listen(({ pathname }) => {
        if (!isVisitProfileModulePath(pathname)) {
            clearModuleState();
        }
    });

    return () => {
        unlisten();
        if (!isVisitProfileModulePath(history.location.pathname)) {
            clearModuleState();
        }
    };
}, [history]);
useEffect(() => {
    if (!allCities?.result || !allTeams?.result) return;
    
    const isInsideModule = sessionStorage.getItem(MODULE_FLAG) === "true";
    const savedState = isInsideModule
        ? JSON.parse(localStorage.getItem(VISIT_PROFILE_STATE_KEY) || "null")
        : null;
    const hasSavedFilters = savedState && (savedState.city || savedState.team);

    if (savedState && hasSavedFilters) {
        setSearchQuery(savedState.search || DEFAULT_SEARCH);
        setCurrentPage(savedState.page || DEFAULT_PAGE);
        setItemsPerPage(savedState.pageSize || DEFAULT_PAGE_SIZE);
        setCityFilter(savedState.city || '');
        setTeamFilter(savedState.team || '');
        setShowFilters(
            typeof savedState.showFilters === "boolean"
                ? savedState.showFilters
                : false
        );
        console.log('Loading saved filters:', { city: savedState.city, team: savedState.team });
    } else {
        setSearchQuery(DEFAULT_SEARCH);
        setCurrentPage(DEFAULT_PAGE);
        setItemsPerPage(DEFAULT_PAGE_SIZE);
        const defaultCityFilter = currentUserCityId ? String(currentUserCityId) : '';
        const defaultTeamFilter = currentUserTeamId ? String(currentUserTeamId) : '';
        
        setCityFilter(defaultCityFilter);
        setTeamFilter(defaultTeamFilter);
        setShowFilters(false);
        
    }

    sessionStorage.setItem(MODULE_FLAG, "true");
    setIsReady(true);
    setIsInitialized(true);
    setInitialLoad(false);
}, [allCities, allTeams, currentUserCityId, currentUserTeamId]);
    // Fetch visit profiles when filters change
useEffect(() => {
    if (!isReady) return;
    const body = {
        filter: {
            textSearch: searchQuery,
            city: cityFilter,
            team: teamFilter
        },
        pageNumber: currentPage,
        itemsPerPage: itemsPerPage
    };
    dispatch(getvisitProfile(body));
}, [currentPage, searchQuery, itemsPerPage, cityFilter, teamFilter, isReady, dispatch]);
    // Save state to localStorage whenever filters change
useEffect(() => {
    if (isInitialized) {
        const filterState = {
            city: cityFilter,
            team: teamFilter,
            search: searchQuery,
            page: currentPage,
            pageSize: itemsPerPage,
            showFilters,
        };
        localStorage.setItem(VISIT_PROFILE_STATE_KEY, JSON.stringify(filterState));
        sessionStorage.setItem(MODULE_FLAG, 'true');
    }
}, [cityFilter, teamFilter, searchQuery, currentPage, itemsPerPage, showFilters, isInitialized]);
// Load cities and teams on mount
useEffect(() => {
    const loadFilters = async () => {
        try {
            const cityBody = {
                filter: { textSearch: '', countryId: '1' },
                pageNumber: -1,
                pageSize: 0,
            };

            dispatch(getCities(cityBody)).then(() => {
                setCitiesLoaded(true);
                console.log('Cities loaded');
            });

            dispatch(getTeams(-1, 0, '')).then(() => {
                setTeamsLoaded(true);
                console.log('Teams loaded');
            });
        } catch (error) {
            console.error('Error loading filters:', error);
        }
    };

    loadFilters();
}, [dispatch]);
   const handleItemsPerPageChange = (value) => {
    setItemsPerPage(value);
    setCurrentPage(1);
};
    const handleAddVisitProfileClick = () => {
        history.push({
            pathname: '/admin/AddVisitProfile',
            state: {
                fromVisitProfile: true,
                page: currentPage,
                search: searchQuery,
                pageSize: itemsPerPage
            }
        });
    };
   const handleEditVisitProfile = (row) => {
    history.push({
        pathname: '/admin/UpdateVisitProfile',
        visitProfile: { row },
        id: row.visitProfileId,
    });
};
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
        setCurrentPage(1);
    };

const toggleFilters = () => {
    setShowFilters(!showFilters);
};

const handleCityFilterChange = (event) => {
    setCityFilter(event.target.value);
    setCurrentPage(1);
};

const handleTeamFilterChange = (event) => {
    setTeamFilter(event.target.value);
    setCurrentPage(1);
};

const handleClearAllFilters = () => {
    if (cityFilter === '' && teamFilter === '') return;

    setCityFilter('');
    setTeamFilter('');
    setCurrentPage(1);
};
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (assigneeListRef.current && !assigneeListRef.current.contains(event.target)) {
                setExpandedRowId(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    useEffect(() => {
        function handleClickOutside(event) {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                handleCancelDelete();
            }
        }

        if (openModal) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openModal]);

    const handleCancelDelete = () => {
        setOpenModal(false);
        setSelectedVisitProfileId(null);
    };

    const handleConfirmDelete = () => {
    if (selectedVisitProfileId) {
        dispatch(deleteVisitProfile(selectedVisitProfileId)).then(() => {
            const body = {
                filter: {
                    textSearch: searchQuery,
                    city: cityFilter,
                    team: teamFilter
                },
                pageNumber: currentPage,
                itemsPerPage: itemsPerPage
            };
            dispatch(getvisitProfile(body));
        });
    }
    setOpenModal(false);
    setSelectedVisitProfileId(null);
};

    const handleOpenModal = (row) => {
        setSelectedVisitProfileId(row.visitProfileId);
        setOpenModal(true);
    };

    const totalPages = visitProfile?.totalPages || 0;
    const totalItems = visitProfile?.totalCount || 0;

    const columns = [
        { label: `${t("name")}`, accessor: 'systemGeneratedName' },
        { label: `${t("displayName")}`, accessor: 'profileName' },
        { label: `${t("city")}`, accessor: 'cityName' },
        { label: `${t("assignedTo")}`, accessor: 'assigneesDisplay' },
        { label: `${t("createdBy")}`, accessor: 'createdByDisplay' }
    ];

    const toggleAssigneeList = (rowId, event) => {
        event.stopPropagation();
        setExpandedRowId(expandedRowId === rowId ? null : rowId);
    };

    const processedData = (visitProfile?.result || []).map(item => {
        const processedItem = { ...item };
        const rowId = item.visitProfileId;
        const isExpanded = expandedRowId === rowId;

        if (item.assignees && Array.isArray(item.assignees) && item.assignees.length > 0) {
            if (item.assignees.length === 1) {
                const assignee = item.assignees[0];
                processedItem.assigneesDisplay = (
                    <div className="assignee-single">
                        <div className="assignee-details">
                            <div className="assignee-name">{assignee.name}</div>
                            {assignee.designationName && (
                                <div className="assignee-designation">{assignee.designationName}</div>
                            )}
                        </div>
                    </div>
                );
            } else {
                processedItem.assigneesDisplay = (
                    <div className="assignees-container">
                        <div className="avatars-row">
                            {item.assignees.slice(0, 3).map((assignee, index) => {
                                const isLastVisibleAvatar =
                                    (index === item.assignees.length - 1 && item.assignees.length <= 3 && item.assignees.length > 1);

                                return (
                                    <div
                                        key={assignee.id}
                                        className={`avatar-circle ${isLastVisibleAvatar ? 'last-avatar' : ''}`}
                                        style={{
                                            left: `${index * 22}px`,
                                            zIndex: 10 - index,
                                            cursor: isLastVisibleAvatar ? 'pointer' : 'default'
                                        }}
                                        title={assignee.name}
                                        onClick={(e) => isLastVisibleAvatar && toggleAssigneeList(rowId, e)}
                                    >
                                        {assignee.name.charAt(0).toUpperCase()}
                                    </div>
                                );
                            })}

                            {item.assignees.length > 3 && (
                                <div
                                    className="avatar-counter"
                                    style={{ left: `${3 * 22}px`, cursor: 'pointer' }}
                                    onClick={(e) => toggleAssigneeList(rowId, e)}
                                >
                                    +{item.assignees.length - 3}
                                </div>
                            )}
                        </div>

                        {isExpanded && (
                            <div
                                className="assignees-expanded"
                                ref={assigneeListRef}
                            >
                                <div className="assignees-list">
                                    {item.assignees.map(assignee => (
                                        <div key={assignee.id} className="assignee-item">
                                            <div className="assignee-avatar">
                                                {assignee.name.charAt(0).toUpperCase()}
                                            </div>
                                            <div className="assignee-details">
                                                <div className="assignee-name">{assignee.name}</div>
                                                {assignee.designationName && (
                                                    <div className="assignee-designation">{assignee.designationName}</div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                );
            }
        } else {
            processedItem.assigneesDisplay = (
                <span style={{ color: '#999' }}>Not available</span>
            );
        }
        if (item.createdBy && item.createdBy.name && item.createdBy.name.trim() !== "") {
            processedItem.createdByDisplay = item.createdBy.name;
        } else {
            processedItem.createdByDisplay = (
                <span style={{ color: '#999' }}>Not available</span>
            );
        }
        if (!item.systemGeneratedName) {
            processedItem.systemGeneratedName = (
                <span style={{ color: '#999' }}>Not available</span>
            );
        }
        return processedItem;
    });

    const actions = [
        {
            label: 'Delete Visit Profile',
            icon: <DeleteOutlineIcon sx={{color: "#FD511B"}} />,
            permission: 'CanDeleteVisitProfile',
            handler: handleOpenModal,
        },
        {
            label: 'Edit Visit Profile',
            icon: <EditOutlinedIcon sx={{ color: '#0438B4' }}/>,
            permission: 'CanUpdateVisitProfile',
            handler: handleEditVisitProfile,
        },
    ];

    return (
        <>
            <div>
                <LoadingOverlay isVisible={isLoading || initialLoad} />
                <div className="main-container">
                     <div className="content-wrapper" style={{ padding: 0 }}>
    <div className="pagination" style={{ padding: '20px 16px' }}>
    <SearchInput
        placeholder="Search"
        onChange={handleSearchChange}
        value={searchQuery || ""}
    />
    <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ minWidth: '80px', marginRight: '10px' }}>
            <ItemsPerPageSelector
                value={itemsPerPage}
                onChange={handleItemsPerPageChange}
            />
        </div>
        <CustomPagination
            currentPage={currentPage}
            totalItems={totalItems}
            itemsPerPage={itemsPerPage}
            totalPages={totalPages}
            onPageChange={(page) => setCurrentPage(page)}
        />
        <div style={{marginRight: "12px"}}>
            <GenericFilter
                showFilters={showFilters}
                toggleFilters={toggleFilters}
            />
        </div>
        {permissions && permissions.includes(PERMISSIONS.CAN_ADD_VISIT_PROFILE) && (
            <CustomButton
                text={t("addNew")}
                onClick={handleAddVisitProfileClick}
            />
        )}
    </div>
</div>

<FilterBar
    showFilters={showFilters}
    onClearAll={handleClearAllFilters}
>
    <div style={{ position: 'relative', zIndex: 102 }}>
    <CustomFilterSelect
        label={t("city")}
        value={cityFilter}
        onChange={handleCityFilterChange}
        options={[
            { id: '', name: 'All' },
            ...cityOptions
        ]}
        disabled={!citiesLoaded}
        width="220px"
        searchable={true}
        searchPlaceholder="Search cities..."
        noDataText="No cities available"
    />
</div>
  <div style={{ position: 'relative', zIndex: 101 }}>
    <CustomFilterSelect
        label={t("team")}
        value={teamFilter}
        onChange={handleTeamFilterChange}
        options={[
            { id: '', name: 'All' },
            ...teamOptions
        ]}
        disabled={!teamsLoaded}
        width="220px"
        searchable={true}
        searchPlaceholder="Search teams..."
        noDataText="No teams available"
    />
</div>
</FilterBar>
                    </div>
                  
    <DynamicTable
        data={processedData}
        columns={columns}
        permissions={permissions}
        actions={actions}
        thIcon={thIcon}
        showPagination={totalItems > 0}
        currentPage={currentPage}
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
        totalPages={totalPages}
        onPageChange={(page) => setCurrentPage(page)}
        onItemsPerPageChange={handleItemsPerPageChange}
    />

                     
                </div>
                {openModal && (
                    <div className="modal-backdrop">
                        <div className="modal-container" ref={modalRef}>
                            <div className='content-container'>
                                <div className='icon-container'>
                                    <img src={deleteIcon} />
                                </div>
                                <div className='text-container'>
                                    <Heading6Semibold color='#1E293B' text='Delete Visit Profile' />
                                    <BodyMediumRegular
                                        color='#384153'
                                        text='Are you sure you want to delete this visit profile?'
                                        textAlign='center'
                                    />
                                </div>
                            </div>
                            <div className='button-contiainer'>
                                <button className='cancel-button' onClick={handleCancelDelete}>
                                <p className="button-text">Cancel</p>
                                </button>
                                <button className='danger-button' onClick={handleConfirmDelete}>
                                <p className="button-text delete">Delete</p>
                                </button>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </>
    );
};

export default VisitProfile;